import { render } from "./CharacterSelect.vue?vue&type=template&id=6b0e72ca&scoped=true&ts=true"
import script from "./CharacterSelect.vue?vue&type=script&lang=ts"
export * from "./CharacterSelect.vue?vue&type=script&lang=ts"

import "./CharacterSelect.vue?vue&type=style&index=0&id=6b0e72ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0e72ca"]])

export default __exports__